import React, { useRef } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FilterIcon from '@mui/icons-material/FilterListRounded';
import IconButton from '@mui/material/IconButton';
import VerticalDotsIcon from '@mui/icons-material/MoreVert';
import type { TConversationsFilter } from 'src/services/api/messages/use-conversations-search';
import FilterModal, { type FilteringBy } from 'src/pages/landlord/conversations/components/header/ConversationsFilterModal';
import Responsive from 'src/components/responsive';

type Props = {
    isFilterOpen: boolean;
    setFilterOpen: (open: boolean) => void;
    filter: TConversationsFilter;
    teamMembers: Array<any>;
    properties: Array<any>;
    setFilter: (newFilter: Partial<TConversationsFilter>) => void;
    resetFilter: () => void;
    disabledFilters?: FilteringBy[];
}
export default function ConversationsFilterButton({ isFilterOpen, setFilterOpen, filter, teamMembers, properties, setFilter, resetFilter, disabledFilters }: Props) {
    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleClick = () => {
        setFilterOpen(true);
    };

    return (
        <>
            <Responsive mobile>
                <IconButton
                    ref={buttonRef}
                    onClick={handleClick} edge="end"
                >
                    <VerticalDotsIcon />
                </IconButton>
            </Responsive>
            <Responsive desktop>
                <Button
                    ref={buttonRef}
                    color="dark"
                    startIcon={<FilterIcon />}
                    onClick={handleClick}
                    data-testid="filter-button"
                >
                    <Typography mt={0.25} variant="body2">Filter</Typography>
                </Button>
            </Responsive>


            <FilterModal
                anchorEl={buttonRef.current}
                isFilterOpen={isFilterOpen}
                setFilterOpen={setFilterOpen}
                filter={filter}
                teamMembers={teamMembers}
                properties={properties}
                setFilter={setFilter}
                resetFilter={resetFilter}
                disabledFilters={disabledFilters}
            />
        </>
    );
}
